import { useLayoutHeight } from 'app/imports/App.hooks'
import { getYear } from 'date-fns'
import { UISelect } from 'features/UI'
import { useCallback, useMemo } from 'react'
import { SingleValue } from 'react-select'
import { FilterOption } from '../../Schedules.model'

export function SchedulesFilterSeason({
  value,
  onChange,
}: {
  value: FilterOption
  onChange: (value: FilterOption) => void
}) {
  const widgetHeight = useLayoutHeight()

  const seasons = useMemo(() => {
    const list = []
    for (let i = 2012; i <= getYear(new Date()) + 1; i += 1) {
      list.push({
        id: `${i}-${i + 1}`,
        name: `${i} - ${i + 1}`,
      })
    }
    return list
  }, [])

  const handleChange = useCallback(
    (event: SingleValue<FilterOption>) => {
      if (!event) return
      onChange(event)
    },
    [onChange],
  )

  const maxMenuHeight = widgetHeight < 300 ? 60 : 120

  return (
    <UISelect<FilterOption, false>
      options={seasons}
      value={value}
      placeholder="Event type"
      onChange={handleChange}
      isMulti={false}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      isClearable={false}
      maxMenuHeight={maxMenuHeight}
    />
  )
}
